import { Accessor, Match, Switch } from "solid-js";
import { clientIdConfig } from "~/data/partner_config";
import RNRCodeHubbleBranding from "~/components/login-rnr/rnr_code_hubble_branding";

export function BottomStickyBranding$Client(props: {
  clientId: Accessor<string | undefined>;
}) {
  return (
    <Switch>
      <Match when={props.clientId() === clientIdConfig.tdClientId}>
        <div
          id="rnr-hubble-branding-td"
          class=" flex flex-col items-center justify-center border-t border-[#212427] bg-black px-4 py-3"
        >
          <p class="text-center text-bold text-textNormal">
            This portal is created, owned and operated by Gullak Technologies
            Private Limited
          </p>
        </div>
      </Match>
      <Match when={props.clientId() === clientIdConfig.axisClientId}>
        <div class=" flex  flex-col items-center justify-center border-t border-baseTertiaryDark py-2 ">
          <RNRCodeHubbleBranding />
          <p class="w-full px-4  text-center text-bold text-textNormal ">
            For any issues/queries, please contact "support@myhubble.money"
          </p>
        </div>
      </Match>
      <Match when={true}>
        <div class="flex flex-col items-center justify-center py-2">
          <RNRCodeHubbleBranding />
        </div>
      </Match>
    </Switch>
  );
}
